import { styles as S } from '@bob/design-system'
import { RichText } from './RichText'

export type FramedProps = {
    __typename: 'Framed'
    sys: { id: string }
    title: string
    content: {
        json: any
    }
}

export function Framed({ title, content }: FramedProps): React.ReactElement {
    return (
        <S.wysiwyg.Frame>
            <S.heading.TitleCardArticle>{title}</S.heading.TitleCardArticle>
            <RichText document={content.json} />
        </S.wysiwyg.Frame>
    )
}
